export default __webpack_public_path__ + "static/media/pompeSub.ac70f397.png";